import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "General View": { initFrame:  80 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },
    "Lobby": { initFrame:  0 },
    "Lounge juvenil": { initFrame:  120 },
    "Gimnasio y zona fitness": { initFrame:  120 },
    "Biblioteca y sala de juntas": { initFrame:  120 },
    "Zona de niños": { initFrame:  5 },
    "Spa": { initFrame:  120 },

    //"EveryTransition": { importTransition: AllTransitions }
}
